import { error, finish } from '../../../modules/market-templates/actions/selection-template-creation';
import api from '../../../api';

export function request(dispatch, { sportId, eventTemplateId, marketTemplateId, selection }) {
    const path = [
        '/sports/', sportId,
        '/market-templates/', eventTemplateId,
        '/', marketTemplateId,
        '/selections/create'
    ];

    api.post(path.join(''), selection).then(
        selectionTemplate => {
            dispatch(finish(marketTemplateId, selectionTemplate));
        },
        errors => dispatch(error(errors))
    );
}
